import React, { FC } from "react";
import { Plus } from "react-bootstrap-icons"; // eslint-disable-line
import BSButton from "react-bootstrap/Button";

type ButtonProps = {
  title: string;
  handleClick?: () => void;
};

export const Button: FC<ButtonProps> = ({ title, handleClick }) => {
  return (
    <div className="header-add-button-container">
      <BSButton
        variant="primary"
        className="button-content"
        onClick={handleClick}
      >
        <Plus color="#fff" />
        {title}
      </BSButton>
    </div>
  );
};
